function getFormattedDate(date) {
    return date.toISOString().slice(0, 10);
}

function getNightsCount(checkIn, checkOut) {
    const checkInDate = new Date(checkIn).setHours(0, 0, 0, 0);
    const checkOutDate = new Date(checkOut).setHours(0, 0, 0, 0);

    return Math.round((checkOutDate - checkInDate) / (24 * 60 * 60 * 1000));
}

function hasEmptyDate(date) {
    return !date;
}

function hasFilledDate(date) {
    return !!date;
}

function hasEmptyDates(startDate, endDate) {
    return hasEmptyDate(startDate) && hasEmptyDate(endDate);
}

function hasFilledDates(startDate, endDate) {
    return hasFilledDate(startDate) && hasFilledDate(endDate);
}

function hasPartialDates(startDate, endDate) {
    return !hasEmptyDates(startDate, endDate) && !hasFilledDates(startDate, endDate);
}

function hasValidDates(startDate, endDate) {
    const startTimestamp = Date.parse(startDate);
    const endTimestamp = Date.parse(endDate);
    const todayTimestamp = Date.parse(new Date().toISOString().split('T')[0]);

    return (hasFilledDates(startDate, endDate) && startTimestamp >= todayTimestamp && startTimestamp < endTimestamp);
}

export {
    getFormattedDate,
    getNightsCount,
    hasEmptyDate,
    hasEmptyDates,
    hasFilledDate,
    hasFilledDates,
    hasPartialDates,
    hasValidDates
};
